/**
 * Líné načtení pdf.js (render stránek PDF do canvasu).
 * Legacy build kvůli starším Safari na iPadech/telefonech na stavbě.
 * Knihovna je velká (~1 MB), proto se načte až když je opravdu potřeba.
 */
import workerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';

type PdfJs = typeof import('pdfjs-dist/legacy/build/pdf.mjs');
export type PdfDocument = Awaited<ReturnType<PdfJs['getDocument']>['promise']>;

let loader: Promise<PdfJs> | null = null;

function loadPdfJs(): Promise<PdfJs> {
  if (!loader) {
    loader = import('pdfjs-dist/legacy/build/pdf.mjs').then((mod) => {
      mod.GlobalWorkerOptions.workerSrc = workerUrl;
      return mod;
    });
  }
  return loader;
}

export async function openPdf(data: ArrayBuffer): Promise<PdfDocument> {
  const pdfjs = await loadPdfJs();
  // pdf.js si buffer „přivlastní" (transfer do workeru) → předáme kopii,
  // aby původní bajty zůstaly k dispozici pro pdf-lib.
  return pdfjs.getDocument({ data: new Uint8Array(data.slice(0)) }).promise;
}

/** Vykreslí stránku (1-based) do nového canvasu v daném měřítku. */
export async function renderPdfPage(
  doc: PdfDocument,
  pageNumber: number,
  scale: number,
): Promise<HTMLCanvasElement> {
  const page = await doc.getPage(pageNumber);
  const viewport = page.getViewport({ scale });
  const canvas = document.createElement('canvas');
  canvas.width = Math.ceil(viewport.width);
  canvas.height = Math.ceil(viewport.height);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas není k dispozici');
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  // intent 'print': nevyužívá requestAnimationFrame → dokreslí i v pozadí
  // (přepnutá aplikace na telefonu) a anotace vykreslí tak, jak se tisknou.
  await page.render({ canvasContext: ctx, viewport, intent: 'print' }).promise;
  return canvas;
}
